export enum CustomerRfmSegment {
  CHAMPIONS = "CHAMPIONS",
  REGULAR = "REGULAR",
  FORMERLY_ACTIVE = "FORMERLY_ACTIVE",
  INACTIVE = "INACTIVE",
  NEW = "NEW",
}

export enum CustomerRank {
  BRONZE = "BRONZE",
  SILVER = "SILVER",
  GOLD = "GOLD",
}
